//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import logo from "../assets/logo-white.svg";
import { AccountManager } from "@nuskin/ns-account";
import { DirUtil, events } from "@nuskin/ns-util";
import { FooterService } from "@nuskin/ns-product";
import { fromJsonString, getFullUrl } from "@nuskin/ns-common-lib";
import { getConfiguration } from "@nuskin/configuration-sdk";
import "@nuskin/ns-core-styles/src/dist/main.css";

import NsLogo from "./NsLogo.vue";
import NsFooterStorefront from "./NsFooterStorefront.vue";
import NsSocialIcons from "./NsSocialIcons.vue";
import NsFooterNav from "./NsFooterNav.vue";
import vueEventBus from "./EventBus";

export default {
  name: "NsFooter",
  components: { NsFooterStorefront, NsLogo, NsSocialIcons, NsFooterNav },
  props: {
    /**
     * Which country to display
     */
    currentDisplayCountry: {
      type: String,
      default: ""
    },
    /**
     * The country code of the currently displayed country
     */
    currentCountryCode: {
      type: String,
      default: ""
    },
    /**
     * Which language to display
     */
    currentDisplayLanguage: {
      type: String,
      default: ""
    },
    /**
     * The language code of the currently displayed country
     */
    currentLanguageCode: {
      type: String,
      default: ""
    },
    /**
     * Links that go between navigation and seals for legal type stuff
     */
    detailsLinks: {
      type: [String, Array],
      default: null
    },
    /**
     * Will place in anchor HTML for trust arc cookie link
     */
    enablegdprcookiepreferences: Boolean,
    /**
     * Used to lock breakpoints into a certain mode such as desktop, tablet, or mobile (deprecated)
     */
    expandbreakpoint: {
      type: String,
      default: "none"
    },
    /**
     * Option to hide the country/language dropdown
     */
    hideCountryLanguageDropdown: Boolean,
    /**
     * Option to hide the join button
     */
    hideJoinButton: Boolean,
    /**
     * Option to hide the logo section
     */
    hideLogo: Boolean,
    /**
     * Option to hide the social icons section
     */
    hideSocial: Boolean,
    /**
     * text for the button to join NuSkin
     */
    joinNuskin: {
      type: String,
      default: ""
    },
    /**
     * Where the join button should take the user
     */
    joinNuskinUrl: {
      type: String,
      default: ""
    },
    /**
     * The text for the country/language dropdown
     */
    langButtonText: {
      type: String,
      default: ""
    },
    /**
     * Where to redirect the user when they click the logo
     */
    logoURL: {
      type: String,
      default: logo
    },
    /**
     * Used to determine if the mysite/storefront footer style should be used.
     */
    mysite: Boolean,
    /**
     * Used to force the component to ignore My Site footer data.
     */
    noMysite: Boolean,
    /**
     * An array of navigation objects. Each object should contain: title, links,  addedContent (optional)
     */
    navigation: {
      type: [String, Array],
      default: null
    },
    /**
     * Will hide the top part of the footer. Use if you want a simple footer.
     */
    noExpandedFooter: Boolean,
    /**
     * Pull data from the AEM footer service if not sent in attributes
     */
    noFooterService: Boolean,
    /**
     * An array of objects for seal information. Each object should contain: title, sealImageUrl
     */
    seals: {
      type: [String, Array],
      default: null
    },
    /**
     * Title text for the social icons section
     */
    socialMediaHeaderText: {
      type: String,
      default: ""
    },
    /**
     * An array of social media items. Each object should contian: unknown
     */
    socialMediaList: {
      type: [String, Array],
      default: null
    },
    /**
     * Object of storefront values you can pass in directly instead of using service
     */
    storefront: {
      type: Object,
      default: null
    },
    /**
     * (DEPECRECATED) Used to style footer in storefront.
     * WARNING: Please use the mysite prop instead, to be consistent with NsHeader component.
     */
    storefrontFooter: Boolean,
    /**
     * Analytics id for click event
     */
    analyticsId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      footerData: {},
      minimal: {
        value: false,
        loaded: false
      }
    };
  },
  computed: {
    market() {
      return this.$NsAppService.runConfig.market || "";
    },
    language() {
      return this.$NsAppService.runConfig.language || "";
    },
    siteUrl() {
      return this.$NsAppService.siteUrl || "";
    },
    isStorefront() {
      return !!this.$NsAppService.isStorefront;
    },
    useMysiteFooter() {
      return (
        !this.noMysite &&
        (this.isStorefront || this.mysite || this.storefrontFooter)
      );
    },
    dir() {
      return DirUtil.getDir();
    },
    showJoinButton() {
      return !AccountManager.isLoggedIn();
    },
    // noFooterService must be true if you don't want to pull default data from AEM
    footer() {
      let navigation = this.useMysiteFooter
        ? (this.footerData.storefront || {}).navigation
        : this.footerData.navigation;
      return {
        currentCountryCode:
          this.currentCountryCode ||
          this.market ||
          this.footerData.currentCountryCode ||
          "US",
        currentDisplayCountry:
          this.currentDisplayCountry ||
          this.footerData.currentDisplayCountry ||
          "United States",
        currentDisplayLanguage:
          this.currentDisplayLanguage ||
          this.footerData.currentDisplayLanguage ||
          "English",
        currentLanguageCode:
          this.currentLanguageCode ||
          this.language ||
          this.footerData.currentLanguageCode ||
          "en",
        detailsLinks: this.useMysiteFooter
          ? (this.footerData.storefront || {}).detailsLinks || []
          : this.j(this.detailsLinks) || this.footerData.detailsLinks || [],
        seals: this.j(this.seals) ||
          this.footerData.seals || [
            {
              title: "Direct Selling Association",
              sealImageUrl: "/content/dam/apps/ns_footer_assets/DSA.png"
            },
            {
              title: "Better Business Bureau",
              sealImageUrl: "/content/dam/apps/ns_footer_assets/BBB.png"
            },
            {
              title: "Direct Selling Education Fund",
              sealImageUrl: "/content/dam/apps/ns_footer_assets/DSEF.png"
            }
          ],
        enablegdprcookiepreferences:
          this.enablegdprcookiepreferences ||
          this.footerData.enableGDPR ||
          false,
        hideLanguageCountryDropdown:
          this.hideLanguageCountryDropdown ||
          this.footerData.hideLanguageCountryDropdown ||
          true,
        joinNuskin:
          this.joinNuskin || this.footerData.joinNuskinLabel || "Join Nu Skin",
        joinNuskinUrl:
          this.joinNuskinUrl ||
          this.footerData.joinNuskinUrl ||
          "/content/nuskin/en_US/sign-up.html",
        navigation: this.j(this.navigation) || navigation || [],
        overrideLogo:
          this.overrideLogo || this.footerData.overrideLogo || false,
        socialMediaHeaderText:
          this.socialMediaHeaderText ||
          this.footerData.socialMediaHeaderText ||
          "CONNECT WITH NU SKIN",
        socialMediaList:
          this.socialMediaList || this.footerData.socialMediaList || [],
        storefront: this.storefront || this.footerData.storefront || {}
      };
    },
    showSocialIcons() {
      return (
        !!this.footer.socialMediaList &&
        this.footer.socialMediaList.length > 0 &&
        !this.hideSocial
      );
    }
  },
  async beforeCreate() {
    try {
      const config = await getConfiguration(["Equinox_Markets"]);
      const active = config.Equinox_Markets.active;

      this.minimal = {
        active: active,
        loaded: true
      };
    } catch (e) {
      this.minimal = {
        loaded: true,
        value: false
      };
    }
  },
  mounted() {
    this.addListeners();
  },
  destroyed() {
    this.removeListeners();
  },
  methods: {
    hasValidLink(item) {
      return item.sealImageUrl && item.sealImageUrl !== "#";
    },

    async getFooterData() {
      if (this.noFooterService) {
        return;
      }

      this.footerData = await FooterService.getFooterData();
    },

    // short alias for fromJsonString
    j(string, defaultValue) {
      return fromJsonString(string, defaultValue);
    },

    joinButtonClick() {
      if (this.analyticsId) {
        events.publish(events.shop.NS_JOIN_NUSKIN_FOOTER_CLICKED, {
          data: this.analyticsId
        });
      }
    },

    getFullyQualifiedUrl(url) {
      return getFullUrl(this.siteUrl, url);
    },

    /**
     * Subscribe to events, should only be called when mounted
     */
    addListeners() {
      // watch app service, user service, and feature flag service finished loading
      // listen for run config changes
      events.subscribe(
        events.global.RUN_CONFIG_CHANGED,
        this.$NsAppService.checkConfig
      );

      // watch app service, user service, and feature flag service finished loading
      this.$watch(
        function() {
          return !this.$NsAppService.loading;
        },
        this.getFooterData,
        {
          immediate: true
        }
      );

      // listen to config changes
      vueEventBus.$on("config-changed", this.getFooterData);
      events.subscribe("updateHeaderLanguage", this.getFooterData);
    },

    /**
     * Unsubscribe from events, should only be called when destroyed
     */
    removeListeners() {
      // stop listening to event bus
      vueEventBus.$off();
      events.unsubscribe("updateHeaderLanguage", this.getFooterData);
      events.unsubscribe(
        events.global.RUN_CONFIG_CHANGED,
        this.$NsAppService.checkConfig
      );
    }
  }
};
